import isNullOrUndefined from "_shared/_utilities/is-null-or-undefined";
import { JSONType } from "work/proposals/redlining/field-redlines/field-redline";
import z from "zod";

type BooleanPrimitive = string | number | boolean;

export default class AHBoolean {
  public static readonly type = z.custom<AHBoolean>((value) => value instanceof AHBoolean, {
    message: "Invalid Boolean",
  });

  public static get truthyValues(): BooleanPrimitive[] {
    return [true, "true", 1, "1", "yes", "Yes", "YES"];
  }
  public static get falsyValues(): BooleanPrimitive[] {
    return [false, "false", 0, "0", "no", "No", "NO"];
  }

  public static fromJSON(json: unknown): AHBoolean | undefined {
    if (isNullOrUndefined(json)) return undefined;
    if (typeof json !== "string" && typeof json !== "number" && typeof json !== "boolean")
      throw new InvalidAHBooleanJSONError({
        json,
        message: "Cannot create AHBoolean from non-primitive value",
      });
    if (AHBoolean.truthyValues.includes(json)) return new AHBoolean(true);
    if (AHBoolean.falsyValues.includes(json)) return new AHBoolean(false);
    throw new InvalidAHBooleanJSONError({ json });
  }

  public get isEmpty(): boolean {
    return !this.value;
  }
  constructor(public readonly value: boolean) {}

  public valueOf(): boolean {
    return this.value;
  }
  public toString(): string {
    return this.value.toString();
  }
  public toJSON(): boolean {
    return this.value;
  }
  public isEqualTo(other: unknown): boolean {
    if (!(other instanceof AHBoolean)) return false;
    return this.value === other?.value;
  }

  public clone(): AHBoolean {
    return new AHBoolean(this.value);
  }
}

export class InvalidAHBooleanJSONError extends Error {
  public readonly json: JSONType;
  public readonly message: string = `Cannot create AHBoolean from invalid value`;
  constructor(args: { json: JSONType; message?: string }) {
    super(`${args.message}: ${JSON.stringify(args.json)}`);
    this.json = args.json;
    if (args.message) this.message = args.message;
  }
}
